import React, { useEffect } from 'react';
import { ProposalEntity, RootState, SearchEntity } from 'v2/models';
import { useSelector } from 'react-redux';
import styles from './dataRequestWaitingForSellerProposal.module.scss';
import { WaitingSellerActions } from '../../DataRequestItem/WaitingSellerActions';
import classnames from 'classnames';
import ProposalRespondContent from '../../ActiveDataRequests/ProposalRespondModal/ProposalRespondContent';
import { FormProvider } from 'react-hook-form';
import { useFormProposalResponse } from 'v2/queries/useFormProposalResponse';
import { useProposalResponseAccepted } from 'v2/queries/useProposalResponseAccepted';
import FooterButtons from '../../ActiveDataRequests/ProposalRespondModal/FooterButtons';
import { isWaitingForSellerProposal } from 'v2/utils/proposalUtils';

export interface OwnProps {
  proposal: ProposalEntity;
}

const DataRequestWaitingForSellerProposal = ({ proposal }: OwnProps) => {
  const user = useSelector((state: RootState) => state.user.user);
  const search = proposal.search as SearchEntity;

  const {
    removeResponseKey,
    setResponseKey,
    data: currentProposalResponse,
  } = useProposalResponseAccepted({
    proposalId: proposal.id,
    searchId: search.id,
  });

  const { formContext, onSubmit, isBusy, isCheckSellerResponseEnabled } =
    useFormProposalResponse({ proposal });

  const { handleSubmit, register, watch } = formContext;

  useEffect(() => {
    register('data_files');
  }, [register]);

  const showButtons =
    isWaitingForSellerProposal(proposal) && Boolean(currentProposalResponse);

  const checkResponse = watch('check_seller_response_status');

  const showTooltip = isCheckSellerResponseEnabled && !checkResponse && !isBusy;

  return (
    <FormProvider {...formContext}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className={classnames('pl-4', styles.rightContent)}>
          {currentProposalResponse ? (
            <ProposalRespondContent
              proposal={proposal}
              isDetailsFormat={true}
            />
          ) : (
            <div className={styles.actionButtons}>
              <WaitingSellerActions
                proposal={proposal}
                onRespondProposal={() => setResponseKey()}
                user={user}
                detailsFormatTitle="Your Response"
              />
            </div>
          )}
        </div>
        {showButtons && (
          <div className={classnames(styles.proposalButtons)}>
            <div
              className={classnames(
                'm-0 container-xl d-flex align-items-center buttons pt-4',
                styles.proposalButtonsContainer
              )}
            >
              <FooterButtons
                isSubmitDisabled={isBusy}
                onCancel={removeResponseKey}
                showSubmitTooltip={showTooltip}
                isDetailsFormat={true}
              />
            </div>
          </div>
        )}
      </form>
    </FormProvider>
  );
};

export default DataRequestWaitingForSellerProposal;
